/**
 * SGKC030A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CtrContInfo {

    /**
     * 契約者お客さま漢字氏名
     */
    ctrperName?: string;
    /**
     * 郵便番号
     */
    description?: string;
    /**
     * 市区郡町村名称
     */
    mptAname?: string;
    /**
     * 町域名称
     */
    townAreaName?: string;
    /**
     * 大字丁目名称
     */
    ooazaName?: string;
    /**
     * 番地・号・分筆号
     */
    blockgoulot?: string;
    /**
     * 住宅・棟号漢字名
     */
    visitSupadrAname?: string;
    /**
     * 屋号・業種漢字名
     */
    visitYagouAname?: string;
    /**
     * 契約お客さま番号
     */
    firstSrvctrNo?: string;
    /**
     * プロダクトコード
     */
    prdCode?: string;
    /**
     * プロダクト正式名称
     */
    prdAname?: string;
    /**
     * サービス契約締結日付
     */
    prdCtrDate?: string;
    /**
     * 契約満了予定日付
     */
    contractexpireScddt?: string;
    /**
     * 地区コード
     */
    areacode?: string;
    /**
     * 使用者お客さま漢字氏名
     */
    userName?: string;
}

